import '.e{display:flex;}.ssr-plugin'
import '.f{flex-direction:column;}.ssr-plugin'
import '.fg{gap:24px;}.ssr-plugin'
import '.ai{position:relative;}.ssr-plugin'
import '.cu{margin-bottom:24px;}.ssr-plugin'
import '.fh{gap:20px;}.ssr-plugin'
import '.v{border-radius:16px;}.ssr-plugin'
import '.d6{aspect-ratio:1/1;}.ssr-plugin'
import '.fi{width:112px;}.ssr-plugin'
import '.fj{height:112px;}.ssr-plugin'
import '.fk{min-width:112px;}.ssr-plugin'
import '.fl{min-height:112px;}.ssr-plugin'
import '.ba{object-fit:cover;}.ssr-plugin'
import '.cy{justify-content:center;}.ssr-plugin'
import '.fm{align-items:left;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.fn{font-size:16px;}.ssr-plugin'
import '.fo{margin-bottom:8px;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.cc{gap:12px;}.ssr-plugin'
import '.fp{margin-bottom:16px;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.ah{height:1px;}.ssr-plugin'
import { styled } from 'inlines'
import { VoteButton } from './VoteButton.js'
import { colors } from '../utils/colors.js'
import { Flag } from './Flag.js'
import { getVotingRegionName } from '../hooks/useVotingRegion.js'
import { MOBILE } from '../utils/breakpoints.js'
import { parseContestantImageSrc } from '../utils/parseImageSrc.js'
import { useDictionary } from '../hooks/useDictionary.js'

type SingleCartItemProps = {
  isPhone?: boolean
  item: {
    name: string
    song: string
    votingRegion: string
    image: { src?: string }
  }
  votes?: Record<string, number>
  setVotes?: (selected: Record<string, number>) => void
  maxed?: boolean
  price?: number
  currency?: string
  lang?: string
  ddi?: string
}

export const SingleCartItem = ({
  isPhone,
  item,
  votes,
  setVotes,
  maxed,
  price,
  currency,
  lang,
  ddi,
}: SingleCartItemProps) => {
  const { name, song, votingRegion, image } = item

  const votingRegionName = getVotingRegionName(votingRegion, lang as string)
  const { vote } = useDictionary()

  return (
    <div className="e f fg ai cu"
      id={`cart-page-item-${votingRegion}`}
    >
      <div className="e fh"
      >
        <img className="v d6 fi fj fk fl ba"
          src={parseContestantImageSrc(image?.src as string, 128)}
          style={{
            border: `1px solid ${colors.border}`,}}
        />
        <div className="e cy fm f m"
        >
          <styled.p className="fn fo"
            style={{
              [MOBILE]: { fontSize: '14px' },
            }}
          >
            {isPhone && ddi + ' · '} {name} · {song}
          </styled.p>
          <div className="e w cc fp"
          >
            <Flag code={votingRegion} width={16} height={16} />
            <styled.p className="fn"
              style={{ [MOBILE]: { fontSize: '14px' } }}
            >
              {votingRegionName}
            </styled.p>
          </div>
          <div className="e m ao w"
          >
            {isPhone ? (
              <styled.p className="fn"
                style={{ [MOBILE]: { fontSize: '14px' } }}
              >
                1 {vote}
              </styled.p>
            ) : (
              <styled.div>
                <VoteButton
                  id={`cart-vote-btn-${votingRegion}`}
                  votes={votes}
                  setVotes={setVotes}
                  votingRegion={votingRegion}
                  maxed={maxed}
                />
              </styled.div>
            )}
            <styled.p className="fn"
              style={{ [MOBILE]: { fontSize: '14px' } }}
            >
              {currency}{' '}
              {(() => {
                const v = votes?.[votingRegion]
                if (v === undefined)
                  console.warn(
                    'SingleCartItem: votes missing for',
                    votingRegion,
                  )
                if (price === undefined)
                  console.warn('SingleCartItem: price missing')
                return (((v ?? 0) * (price ?? 0)) / 100).toFixed(2) // SAFE: zero when data not yet loaded
              })()}
            </styled.p>
          </div>
        </div>
      </div>

      <div className="ah m"
        style={{
          background: `${colors.border}`,}}
      />
    </div>
  )
}
